import { getApps, initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDht4uMhUziAhVasHjjXDFtyzCBdAuRx-I",
  authDomain: "avisa-62fff.firebaseapp.com",
  projectId: "avisa-62fff",
  storageBucket: "avisa-62fff.firebasestorage.app",
  messagingSenderId: "359239180481",
  appId: "1:359239180481:web:f6d80e26f5decb7f5af440",
  measurementId: "G-1ET8SPZL83"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Core Firebase services used by the app
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);

const SECONDARY_APP_NAME = "secondary-auth";

const getSecondaryApp = () => {
  const existing = getApps().find((a) => a.name === SECONDARY_APP_NAME);
  return existing || initializeApp(firebaseConfig, SECONDARY_APP_NAME);
};

// Create users without affecting the main signed-in session.
const getSecondaryAuth = () => {
  return getAuth(getSecondaryApp());
};

// Write Firestore data as the secondary signed-in user.
const getSecondaryDb = () => {
  return getFirestore(getSecondaryApp());
};

// Analytics is only supported in a browser environment
let analytics = null;
isSupported().then((supported) => {
  if (supported) {
    analytics = getAnalytics(app);
  }
});

export { app, auth, db, storage, analytics, getSecondaryAuth, getSecondaryDb };
